import Style from './FJGlobalLoading.module.less';

let FJGlobalLoading = () => {
    return (
        <div className={Style.box}>
            <svg viewBox='0 0 50 50' className={Style.svg_load}>
                <circle cx='25' cy='25' r={25} fill='none' className={Style.svg_loading} />
            </svg>
        </div>
    );
};
export default FJGlobalLoading;
